import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import { useApiMutation } from '@/modules/common';

import { EventNumberField } from './event-number-field';

interface ParticipantUsageLeftInputProps {
  eventId: string;
  participantId: string;
  defaultValue: string;
}

const MAX_USAGES_LEFT = 1000;

export function ParticipantUsageLeftInput({
  eventId,
  participantId,
  defaultValue,
}: ParticipantUsageLeftInputProps) {
  const queryClient = useQueryClient();

  const updateParticipantMutation = useApiMutation<{ usagesLeft: number }>(
    `/events/${eventId}/participants/${participantId}`,
    {
      method: 'PATCH',
    },
    {
      onError: () => {
        toast.error('Uh oh! Something went wrong.');
      },
    }
  );

  const handleUpdateParticipant = async (value: number) => {
    try {
      await updateParticipantMutation.mutateAsync({
        usagesLeft: Number(value),
      });
      queryClient.invalidateQueries({ queryKey: ['eventParticipants'] });
    } catch (error) {
      toast.error('Uh oh! Something went wrong.');
    }
  };

  return (
    <EventNumberField
      defaultValue={defaultValue}
      onChange={handleUpdateParticipant}
      maxValue={MAX_USAGES_LEFT}
    />
  );
}
